/**
 * X.25 CRC（CRC-16/MCRF4XX）。
 *
 * MAVLink 的帧校验与 CRC_EXTRA 用的是**同一个**累加器：
 * 多项式 0x1021、初值 0xFFFF、无最终异或、反射（LSB 在前）。
 *
 * 这里按字节表驱动，而不是逐位运算：串口 921600 bps 下每帧都要算一遍，
 * 逐位实现会成为可观的开销，而 256 项的查表只有 512 字节内存。
 */

/** CRC 初值。MAVLink 用 0xFFFF 而不是 0。 */
export const CRC_SEED = 0xffff;

const TABLE = buildTable();

function buildTable(): Uint16Array {
  const table = new Uint16Array(256);
  for (let index = 0; index < 256; index += 1) {
    let accumulator = index;
    for (let bit = 0; bit < 8; bit += 1) {
      accumulator = (accumulator & 1) !== 0 ? (accumulator >>> 1) ^ 0x8408 : accumulator >>> 1;
    }
    table[index] = accumulator;
  }
  return table;
}

/** 把单个字节喂进累加器。 */
export function crcAccumulate(crc: number, byte: number): number {
  return ((crc >>> 8) ^ (TABLE[(crc ^ byte) & 0xff] ?? 0)) & 0xffff;
}

/**
 * 计算一段字节的 CRC。
 *
 * `start` / `end` 允许就地校验帧内某一段而不必先切片 ——
 * 接收热路径上每次切片都是一次分配。
 */
export function crc16X25(bytes: Uint8Array, start = 0, end = bytes.length): number {
  let crc = CRC_SEED;
  for (let index = start; index < end; index += 1) {
    crc = crcAccumulate(crc, bytes[index] ?? 0);
  }
  return crc;
}
